import React from 'react'
import { ChevronLeft, ChevronRight } from '../icons'
import { dataTekst, poprawnaData } from './okres'
import './naglowek-filtrow.css'

const DNI_TYGODNIA = ['niedz.', 'pon.', 'wt.', 'śr.', 'czw.', 'pt.', 'sob.']

function przesun(dzien: string, o: number): string {
  const [r, m, d] = dzien.split('-').map(Number)
  return dataTekst(new Date(r, m - 1, d + o))
}

function dzienTygodnia(dzien: string): string {
  if (!poprawnaData(dzien)) return ''
  const [r, m, d] = dzien.split('-').map(Number)
  return DNI_TYGODNIA[new Date(r, m - 1, d).getDay()]
}

/** Jeden dzień (planowanie w Zamówieniach): ‹ dzień › z kalendarzem i przycisk „Dziś”. */
export const PoleDnia: React.FC<{
  dzien: string
  onZmiana: (d: string) => void
  dzis?: string
}> = ({ dzien, onZmiana, dzis }) => (
  <>
    <div className="nf-dzien">
      <button type="button" className="nf-dzien-krok" aria-label="Poprzedni dzień" onClick={() => onZmiana(przesun(dzien, -1))}>
        <ChevronLeft width={16} height={16} aria-hidden />
      </button>
      <label className="nf-dzien-wartosc">
        <span className="nf-podpis">Dzień</span>
        <span className="nf-dzien-tyg">{dzienTygodnia(dzien)}</span>
        <input
          type="date" aria-label="Dzień" className="nf-data" value={dzien}
          onChange={(e) => { if (poprawnaData(e.target.value)) onZmiana(e.target.value) }}
        />
      </label>
      <button type="button" className="nf-dzien-krok" aria-label="Następny dzień" onClick={() => onZmiana(przesun(dzien, 1))}>
        <ChevronRight width={16} height={16} aria-hidden />
      </button>
    </div>
    <button type="button" className="nf-dzis" onClick={() => onZmiana(dzis ?? dataTekst(new Date()))}>Dziś</button>
  </>
)
